import { Link } from "react-router-dom";
import heroImage from "../../src/assests/images/hero-img.jpg";


function HeroSection() {
  return (
    <section className="hero-section fade-in">
      {/* Background Image */}
        <div className="hero-background">
        <img
            src={heroImage}
            alt="Modern architecture design"
            className="hero-image"
        />
        </div>

      {/* Overlay Content */}
      <div className="hero-overlay">
        <h1 className="hero-title">
        <span className="brand-name">INARA</span>
        <span className="brand-sub">ARCHITECTS AND INTERIORS</span>
        </h1>

        <p className="hero-subtitle">
          Illuminating Space. Inspiring Soul.
        </p>
        <Link to="/Portfolio" className="hero-button">
          Explore Our Works
        </Link>
      </div>
    </section>
  );
}

export default HeroSection;
